<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">아이디</td>
                <td>
                    <div>
                        {{boardDataInfo.mb_id}}
                    </div>
                </td>
                <td class="c_t_title">닉네임</td>
                <td>
                    <div>
                        {{boardDataInfo.mb_nick}}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">언어</td>
                <td>
                    <div>
                        {{returnLangName(boardDataInfo.c_idx)}}
                    </div>
                </td>
                <td class="c_t_title">환불요청일</td>
                <td>
                    <div>
                        {{returnDate(boardDataInfo.created_at)}}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">결제번호</td>
                <td colspan="3">
                    <div>
                        {{boardDataInfo.o_id}}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">걸제수단</td>
                <td>
                    <div>
                        {{storeTypeName()}}
                    </div>
                </td>
                <td class="c_t_title">주문번호</td>
                <td>
                    <div>
                        {{boardDataInfo.id}}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">내용</td>
                <td colspan="3">
                    <div v-html="replaceBr(boardDataInfo.wr_content)">
                    </div>
                </td>
            </tr>
        </table>
    </div>

</template>

<script>
    import BoardValidator from "@/mixins/validators/BoardValidator"
    import util from "@/mixins/util";
    import {mapState, mapGetters} from "vuex";
    import {storeType} from "@/service/orderService";

    export default {
        name: "BoardInfoLayout",
        mixins: [ BoardValidator ],
        components: {},
        props: {
            boardData: {
                type: Object,
                default: () => {return {}},
            },
            setData: {
                type: Function,
                default: () => {},
            }
        },
        data() {
            return {

            }
        },
        computed: {
            ...mapState({
                countries: state => state.country.countries
            }),
            boardDataInfo() {
                if(util.isEmpty(this.boardData.info)) {
                    return {
                        Writer: {},
                    }
                }
                return this.boardData.info
            }
        },
        mounted() {

        },
        methods: {
            returnDate(date=null) {
                if(!date) {
                    return '';
                }
                return this.$moment.unix(date).locale('ko').format('YYYY-MM-DD HH:mm')
            },
            returnLangName(c_idx) {
                let countryIndex = this.countries.findIndex(country => Number(country.c_idx) === Number(c_idx));
                if(countryIndex < 0) {
                    return '';
                }
                return this.countries[countryIndex].lang_name_kr;
            },
            replaceBr(content=null) {
                if(util.isEmpty(content)) {
                    return '';
                }
                return content.replace(/(?:\r\n|\r|\n)/g, '<br>');
            },
            storeTypeName(type) {
                if(util.isEmpty(this.boardDataInfo.ri_store) || util.isEmpty(storeType[this.boardDataInfo.ri_store])) {
                    return '';
                }
                return storeType[this.boardDataInfo.ri_store];
            },

        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
